module.exports = __webpack_public_path__ + "img/icon-search-white-slim.51a8098d.svg";